import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-container">
      <span>&copy; {year} - JMR Technologies</span>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js